import React, { ComponentType } from 'react';
import hoistStatics from 'hoist-non-react-statics';

import { generateStyle } from './generate-style';
import { TWrapper } from './models';

/**
 * Вернуть объект с названием виджета
 */
export const getDisplayName = <U extends {}>(TargetWidget: ComponentType<U>) => ({
    displayName: TargetWidget.displayName || TargetWidget.name || 'UnnamedWidget',
});

/**
 * Создать обертку, добавляющую стайлер и зависимости
 */
export const createWrapper =
    <T, U extends T>(Widget: ComponentType<U>, dependencies?: T): ComponentType<TWrapper<T, U>> =>
    ({ className, styler, ...props }) =>
        <Widget {...dependencies} {...(props as U)} {...generateStyle(styler, className)} />;

/**
 * Добавить изначальные свойства виджета, displayName и любые дополнительные
 */
export const hoist = <T, U>(
    Wrapper: ComponentType<T>,
    Widget: ComponentType<U>,
    ...rest: any[]
): ComponentType<T> =>
    Object.assign(hoistStatics(Wrapper, Widget), getDisplayName(Widget), ...rest);
